module.exports = __webpack_public_path__ + "static/media/missions-icon-circle.4ce8d403.png";